/**
 * React Query hook for LLM usage summary.
 */

import { useQuery } from '@tanstack/react-query';
import { getUsage, type UsageSummary } from '../usageApi';

export function useUsage(days = 30) {
  return useQuery<UsageSummary>({
    queryKey: ['usage', days],
    queryFn: () => getUsage(days),
    staleTime: 5 * 60 * 1000,
  });
}
